export const getAssetUrl = {
  images: (path: string) => {
    return `${process.env.PUBLIC_URL}/files/${path}?v=${Date.now()}`;
  },
  imagesStatic: (path: string) => {
    return `${process.env.PUBLIC_URL}/files/${path}`;
  },
  icons: (filename: string) => {
    return `${process.env.PUBLIC_URL}/assets/${filename}`;
  },
};
